/**
 * Store pour la gestion des animations
 */

import { ref, computed } from 'vue';
import { defineStore } from 'pinia';
import axios from '@js/tools/axios';

export const useAnimationStore = defineStore('animation', (() => {

    // State des animations
    const animations = ref(null);

    /**
     * Retourne l'animation dont l'identifiant est en paramètre
     * @param string animationId
     * @return object|null
     */
    const getAnimation = computed(() => {
        return ((animationId) => {
            const animationList = animations.value ?? [];
            const index = animationList.findIndex((animation) => animation.id === animationId);
            if(index === -1) {
                return null;
            }

            return (animationList[index] ?? null);
        });
    });

    /**
     * Chargement de la liste des animations
     * @return Promise
     */
    const loadAnimations = (() => {

        if(animations.value !== null) {
            return Promise.resolve();
        }

        const path = '/api/animations';

        return axios.get(path).then((response) => {
            if(response && response.data && response.data.success && response.data.animations) {
                animations.value = response.data.animations;
                return Promise.resolve();
            }
            return Promise.reject();
        });

    });

    /**
     * Mise à jour d'une animation dans le store
     * @param object animation
     * @return void
     */
    const updateAnimation = ((animation) => {

        if(animations.value === null) {
            animations.value = [];
        }

        const currentIndex = animations.value.findIndex((currentAnimation) => currentAnimation.id === animation.id);

        if(currentIndex === -1) {
            animations.value.push(animation);
        } else {
            animations.value[currentIndex] = {
                ...animations.value[currentIndex],
                ...animation
            }
        }
    });

    /**
     * Mise à jour des animations
     * @param array animations
     * @return void
     */
    const updateAnimations = ((animations) => {
        animations.value = animations;
    });

    return {
        getAnimation,
        loadAnimations,
        updateAnimation,
        updateAnimations
    };

}));
